import React, { useMemo } from 'react';
import { Skeleton, Tooltip } from 'antd';
import useFetchEventsByAlert from './hooks/useFetchEventsByAlert';
import { isEmpty } from 'lodash';
import Table from '@components/common/Table';
import moment from 'moment';
import { parseAlert } from './hooks/utils';
import { getMetricInfo } from '@src/pages/Alert/manualAlert/constants';
import { convertValue } from '@src/pages/Alert/manualAlert/shared';
import { AlertTitle, StyledCard } from './stlyed';
import { InfoCircleOutlined } from '@ant-design/icons';
import useSetManualAlertAllEventsExport from './hooks/useSetManualAlertAllEventsExport';
import { formatTimeInfo } from '../AIAlert/hooks/utils';

const getColumns = (alert) => {
  const metricsInfo = getMetricInfo();
  const metricInfo = metricsInfo[alert._metric];

  return [
    {
      title: 'Event Time',
      dataKey: 'time',
      key: 'time',
      width: 200,
      dataGetter: ({ rowData }) => moment(rowData.time).format('HH:mm, MMM DD YYYY'),
    },
    {
      title: 'Condition',
      dataKey: 'value',
      key: 'value',
      width: 120,
      dataGetter: ({ rowData }) =>
        `${convertValue(rowData.value, metricInfo.units)} ${metricInfo.units}`,
    },
    {
      title: 'Sample',
      dataKey: 'samples',
      key: 'samples',
      width: 200,
      dataGetter: ({ rowData }) => `${rowData.samples} ${metricInfo.cm_label}`,
    },
  ];
};

function AlertTable({ alertId, activeEventId = null }) {
  const { isLoading, data: alert, interval }: any = useFetchEventsByAlert({ alertId });

  const columns = useMemo(() => {
    if (alert) {
      const parsedAlert = parseAlert(alert);
      return getColumns(parsedAlert);
    }
  }, [alert]);

  useSetManualAlertAllEventsExport({ columns, alert });

  if (isLoading || isEmpty(alert)) {
    return (
      <StyledCard bordered={false}>
        <Skeleton />
      </StyledCard>
    );
  }

  const addActiveClass = ({ rowData }) => (rowData.id === activeEventId ? 'active-event' : '');

  return (
    <StyledCard
      title={
        <h4>
          All Events of <AlertTitle>{alert.name}</AlertTitle>
        </h4>
      }
      extra={
        <Tooltip title={`${formatTimeInfo(interval)}. Lists up to a maximum of 1000 events`}>
          <InfoCircleOutlined />
        </Tooltip>
      }
      bodyStyle={{ padding: 0 }}
    >
      <Table
        style={{ minHeight: 220, width: '100%' }}
        // fixed={true}
        data={alert.events}
        columns={columns}
        headerHeight={50}
        rowHeight={45}
        rowKey="id"
        rowClassName={addActiveClass}
      />
    </StyledCard>
  );
}

export default AlertTable;
